<script>
import FormInput from '@vvg/forum/js/mixins/formInput'
import CkeditorConfig from "@vvg/forum/js/ckeditor/ckeditor-config";

export default {
	name: "CkEditor",
	mixins: [FormInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		},
		'config': {
			type: Object,
			required: false,
			default: () => CkeditorConfig
		}
	},
	mounted() {
		this.initialiseWysiwyg();

		this.$watch('modelValue', (newValue) => {
			let wysiwyg = $(this.$refs.input).data('wysiwyg');
			if (!wysiwyg) {
				return;
			}
			if (wysiwyg.ui.focusTracker.isFocused) {
				return;
			}
			if (wysiwyg.getData() === (newValue ?? '')) {
				return;
			}
			wysiwyg.setData(newValue ?? '');
		});
	},
	beforeUnmount() {
		let wysiwyg = $(this.$refs.input).data('wysiwyg');
		if (wysiwyg) {
			wysiwyg.destroy().catch(error => console.log(error));
		}
	},
	methods: {
		async initialiseWysiwyg() {
			let wysiwyg = await ClassicEditor
				.create(this.$refs.input, this.config)
				.catch(error => console.log(error));

			$(this.$refs.input).data('wysiwyg', wysiwyg);

			wysiwyg.model.document.on('change:data', () => {
				let value = wysiwyg.getData();
				this.changeModelValueTo(value);
			});
		}
	}
}
</script>

<template>
	<div class="my-3" :class="[groupClasses, { 'has-error': hasError }]">
		<label v-if="label" :for="renderedId">{{ label }}</label>
		<div
			v-bind="$attrs"
			:id="renderedId"
			ref="input"
			v-html="modelValue"
			class="field-type-ckeditor"
			:class="{ 'is-invalid': hasError }"
		></div>
		<small v-if="hasError" class="text-danger d-block mt-1">
			{{ form.errors[name] }}
		</small>
	</div>
</template>